import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M89.335 96.665a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#D8FFFF"
      d="M31.548 30.208a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#00D8D8"
      d="M10.066 25.236a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M30.225 99.608a1.5 1.5 0 0 1 0 2.122l-9.994 9.993a1.5 1.5 0 0 1-2.121-2.122l9.993-9.993a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M18.11 99.608a1.5 1.5 0 0 1 2.12 0l9.995 9.993a1.5 1.5 0 0 1-2.122 2.122l-9.994-9.993a1.5 1.5 0 0 1 0-2.122M104.027 71.99a1.5 1.5 0 0 1 1.5 1.5v14.133a1.5 1.5 0 0 1-3 0V73.49a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M95.46 80.557a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 0 1 0 3H96.96a1.5 1.5 0 0 1-1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#D8FFFF"
      d="M80.576 5.772H49.201a4.59 4.59 0 0 0-4.589 4.589v53.518a4.59 4.59 0 0 0 4.59 4.589h43.17a4.59 4.59 0 0 0 4.588-4.589V22.156z"
    />
    <path
      fill="#001A43"
      fillRule="evenodd"
      d="M54.252 22.704a2.25 2.25 0 0 1 2.25-2.25h16.065a2.25 2.25 0 0 1 0 4.5H56.502a2.25 2.25 0 0 1-2.25-2.25M54.252 37.16a2.25 2.25 0 0 1 2.25-2.25h27.077a2.25 2.25 0 1 1 0 4.5H56.502a2.25 2.25 0 0 1-2.25-2.25M54.252 51.614a2.25 2.25 0 0 1 2.25-2.25h27.077a2.25 2.25 0 1 1 0 4.5H56.502a2.25 2.25 0 0 1-2.25-2.25"
      clipRule="evenodd"
    />
    <path
      fill="#0597A3"
      d="M72.66 41.873H42.695l-2.088-2.749A5.38 5.38 0 0 0 36.325 37H20.589A3.59 3.59 0 0 0 17 40.589v38.436a4.44 4.44 0 0 0 4.44 4.44h51.22a4.44 4.44 0 0 0 4.44-4.44V46.312a4.44 4.44 0 0 0-4.44-4.439"
    />
    <path
      fill="#00D8D8"
      d="M71.342 46.689H22.757A5.757 5.757 0 0 0 17 52.446v30.077a5.757 5.757 0 0 0 5.757 5.757h48.585a5.757 5.757 0 0 0 5.757-5.757V52.446a5.757 5.757 0 0 0-5.757-5.757"
    />
    <path
      fill="#0597A3"
      d="M63.131 64.831H30.644a2.04 2.04 0 0 0-2.041 2.041v4.2c0 1.127.914 2.041 2.041 2.041h32.487a2.04 2.04 0 0 0 2.041-2.04v-4.2a2.04 2.04 0 0 0-2.041-2.042"
    />
    <path
      fill="#00D8D8"
      d="M83.924 22.156H96.96L80.576 5.772v13.036a3.35 3.35 0 0 0 3.348 3.348"
    />
  </svg>
);
const SvgEnrichedIconDocumentsBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconDocumentsBrand);
export default Memo;
